import PropTypes from 'prop-types'

// Inline SVGs instead of emoji flags (🇳🇬 etc.) - Windows has no built-in glyphs for
// regional-indicator emoji and falls back to rendering the raw two-letter code as text
// (that's the "NG +234" QA saw instead of a flag), while SVG renders identically everywhere.
// Simplified (not pixel-accurate) - these render at 14px, so fine detail wouldn't show anyway.
const FLAGS = {
  NG: (
    <>
      <rect width='3' height='2' fill='#fff' />
      <rect width='1' height='2' fill='#008751' />
      <rect x='2' width='1' height='2' fill='#008751' />
    </>
  ),
  GH: (
    <>
      <rect width='3' height='0.667' fill='#ce1126' />
      <rect y='0.667' width='3' height='0.667' fill='#fcd116' />
      <rect y='1.333' width='3' height='0.667' fill='#006b3f' />
      <polygon points='1.5,0.75 1.6,1 1.85,1 1.65,1.15 1.73,1.4 1.5,1.25 1.27,1.4 1.35,1.15 1.15,1 1.4,1' fill='#000' />
    </>
  ),
  KE: (
    <>
      <rect width='3' height='2' fill='#fff' />
      <rect width='3' height='0.6' fill='#000' />
      <rect y='0.7' width='3' height='0.6' fill='#bb0000' />
      <rect y='1.4' width='3' height='0.6' fill='#006600' />
    </>
  ),
  ZA: (
    <>
      <rect width='3' height='2' fill='#fff' />
      <rect width='3' height='0.667' fill='#002395' />
      <rect y='1.333' width='3' height='0.667' fill='#de3831' />
      <polygon points='0,0.667 1.3,1 0,1.333' fill='#007a4d' />
    </>
  ),
  GB: (
    <>
      <rect width='3' height='2' fill='#00247d' />
      <path d='M0,0 L3,2 M3,0 L0,2' stroke='#fff' strokeWidth='0.4' />
      <path d='M0,0 L3,2 M3,0 L0,2' stroke='#cf142b' strokeWidth='0.15' />
      <path d='M1.5,0 V2 M0,1 H3' stroke='#fff' strokeWidth='0.5' />
      <path d='M1.5,0 V2 M0,1 H3' stroke='#cf142b' strokeWidth='0.2' />
    </>
  ),
  US: (
    <>
      <rect width='3' height='2' fill='#fff' />
      <g fill='#b22234'>
        <rect y='0' width='3' height='0.154' />
        <rect y='0.308' width='3' height='0.154' />
        <rect y='0.615' width='3' height='0.154' />
        <rect y='0.923' width='3' height='0.154' />
        <rect y='1.231' width='3' height='0.154' />
        <rect y='1.538' width='3' height='0.154' />
        <rect y='1.846' width='3' height='0.154' />
      </g>
      <rect width='1.2' height='1.077' fill='#3c3b6e' />
    </>
  ),
}

const CountryFlag = ({ code, className }) => {
  const flag = FLAGS[code]
  if (!flag) return null
  return (
    <svg
      className={className}
      viewBox='0 0 3 2'
      width='100%'
      height='100%'
      role='img'
      aria-hidden='true'
      style={{ display: 'block' }}
    >
      {flag}
    </svg>
  )
}

CountryFlag.propTypes = {
  code: PropTypes.oneOf(Object.keys(FLAGS)).isRequired,
  className: PropTypes.string,
}

export default CountryFlag
